<div *ngIf="isPageReady" class="flex flex-col gap-3 p-1">

  <div *ngIf="!rrd" class="text-red-600">RRD #{{ params.rrdId }} not found.</div>

  <div *ngIf="rrd">
    <div class="qb-detail-card qb-primary-tint p-3 mb-3">
      <table class="qb-info-table">
        <tr><td class="label">RRD</td>           <td class="value">#{{ rrd.id }}</td></tr>
        <tr><td class="label">Job Order</td>     <td class="value">{{ rrd.returnRequest?.joHeader?.id }}</td></tr>
        <tr><td class="label">Account</td>       <td class="value">{{ rrd.returnRequest?.joHeader?.account?.accountName }}</td></tr>
        <tr><td class="label">Qty</td>           <td class="value">{{ rrd.qty }}</td></tr>
        <tr><td class="label">Decision</td>      <td class="value">{{ rrd.decision }}</td></tr>
        <tr><td class="label">Routing to</td>    <td class="value">{{ destinationLabel }}</td></tr>
      </table>
    </div>

    <div class="qb-detail-card p-3 mb-3">
      <div class="flex items-start justify-between gap-3 mb-2">
        <div class="font-semibold">Product to apply</div>
        <div class="flex gap-2">
          <button pButton type="button"
                  class="p-button-text p-button-sm"
                  icon="pi pi-pencil"
                  [disabled]="submitting"
                  (click)="pickProduct()">
            <span>Change product</span>
          </button>
          <button *ngIf="isOverridden"
                  pButton type="button"
                  class="p-button-text p-button-sm"
                  icon="pi pi-undo"
                  [disabled]="submitting"
                  (click)="revertToOriginal()">
            <span>Revert</span>
          </button>
        </div>
      </div>

      <table *ngIf="selectedProduct" class="qb-info-table">
        <tr><td class="label">Manufacturer</td> <td class="value">{{ selectedProduct.productType?.manufacturer?.name }}</td></tr>
        <tr><td class="label">Style</td>        <td class="value">{{ selectedProduct.productType?.style }}</td></tr>
        <tr><td class="label">Description</td>  <td class="value">{{ selectedProduct.productType?.description }}</td></tr>
        <tr><td class="label">Features</td>     <td class="value">{{ variantText(selectedProduct) }}</td></tr>
      </table>

      <div *ngIf="isOverridden && originalProduct" class="text-xs text-muted italic mt-2">
        Substituted from original:
        {{ originalProduct.productType?.manufacturer?.name }}
        {{ originalProduct.productType?.style }} —
        {{ originalProduct.productType?.description }}
        ({{ variantText(originalProduct) }})
      </div>
    </div>

    <div class="text-sm text-muted mb-3">
      Confirming will allocate <strong>{{ rrd.qty }}</strong> new ItemDetail{{ rrd.qty === 1 ? '' : 's' }},
      mirror the original addons, and immediately print barcode label{{ rrd.qty === 1 ? '' : 's' }}.
      Apply the label{{ rrd.qty === 1 ? '' : 's' }} to the item{{ rrd.qty === 1 ? '' : 's' }} and place
      in {{ destinationLabel }}.
    </div>

    <div *ngIf="errorMessage" class="text-red-600 mb-2">{{ errorMessage }}</div>
  </div>

  <div class="flex justify-end gap-2 pt-3 border-t">
    <button pButton type="button"
            class="p-button-text"
            [disabled]="submitting"
            (click)="cancel()">
      <span>Cancel</span>
    </button>
    <button pButton type="button"
            class="p-button-raised"
            icon="pi pi-print"
            [disabled]="!canSubmit"
            (click)="routeAndPrint()">
      <span>Route &amp; Print</span>
    </button>
  </div>
</div>
